import type { TSerializedWidget } from 'src/entities/workspace/types';
import type {
  TWellBroadcastWidgetSerializedInternalState,
  ImageBroadcastWidgetEntity,
} from 'src/pages/dashboard/features/image-broadcast-widget/ImageBroadcastWidget.entity';

export function serializeImageBroadcastWidget(widget: ImageBroadcastWidgetEntity): TSerializedWidget {
  const internalState: TWellBroadcastWidgetSerializedInternalState = {
    wellId: widget.wellId,
    stateParams: {
      timeZone: widget.stateParams.timeZone,
      broadcastId: widget.stateParams.broadcastId,
      wellboreId: widget.stateParams.wellboreId,
      isPlaying: widget.stateParams.isPlaying,
      isTooltipVisible: widget.stateParams.isTooltipVisible,
      visiblePanels: widget.stateParams.visiblePanels,
      commentsPanelRatio: widget.stateParams.commentsPanelRatio,
      selectedComment: widget.stateParams.selectedComment,
      imageTransformState: widget.stateParams.imageTransformState,
    },
  };

  return {
    wellId: widget.wellId,
    uuid: widget.uuid,
    type: widget.type,
    groupId: widget.groupId,
    size: {
      w: widget.size.w,
      h: widget.size.h,
    },
    position: {
      x: widget.position.x,
      y: widget.position.y,
    },
    isFullscreen: widget.isFullscreen,
    internalState,
  };
}
